import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=dcc14b3c&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./notice.vue?vue&type=style&index=1&id=dcc14b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc14b3c",
  null
  
)

export default component.exports